var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import Icon from '../icon/Icon';
import { mdiClose } from '@mdi/js';
import { usePopperTooltip } from 'react-popper-tooltip';
import { ButtonIcon } from '../icon';
import { COLORS } from '../color';
var CustomPopover = function (_a) {
    var children = _a.children, content = _a.content, _b = _a.place, place = _b === void 0 ? 'right' : _b, _c = _a.size, size = _c === void 0 ? 'sm' : _c, defaultIsOpen = _a.defaultIsOpen, icon = _a.icon, isClosed = _a.isClosed, isShowCloseButton = _a.isShowCloseButton, classNameMap = _a.classNameMap, iconCloseSize = _a.iconCloseSize, isNotCloseOnOutsideClick = _a.isNotCloseOnOutsideClick;
    var _d = React.useState(defaultIsOpen), controlledVisible = _d[0], setControlledVisible = _d[1];
    var _e = usePopperTooltip({
        closeOnOutsideClick: !defaultIsOpen || !isNotCloseOnOutsideClick,
        placement: place,
        trigger: 'click',
        visible: controlledVisible,
        onVisibleChange: function (isVisible) {
            setControlledVisible(isVisible);
        },
        offset: [0, 8],
    }), getArrowProps = _e.getArrowProps, getTooltipProps = _e.getTooltipProps, setTooltipRef = _e.setTooltipRef, setTriggerRef = _e.setTriggerRef, visible = _e.visible;
    useEffect(function () {
        if (isClosed) {
            setControlledVisible(false);
        }
    }, [isClosed, setControlledVisible]);
    return (React.createElement("div", null,
        React.createElement("div", { className: 'd-flex align-items-center tooltip-child ' +
                ((classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.container) ? classNameMap.container : '') },
            React.createElement("div", { className: (classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.children) ? classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.children : 'mr-x2', ref: icon ? null : setTriggerRef }, children),
            icon && (React.createElement(Icon, { ref: setTriggerRef, path: icon, color: COLORS.gray600, size: 0.7, className: 'cursor-pointer' })),
            visible && (React.createElement("div", __assign({ ref: setTooltipRef }, getTooltipProps({
                className: 'popover-content caption ' +
                    (size ? size : '') +
                    ' ' +
                    ((classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popover) ? classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popover : ''),
            })),
                React.createElement("div", { className: 'popover-body ' + ((classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popoverBody) ? classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popoverBody : '') },
                    isShowCloseButton && (React.createElement(ButtonIcon, { iconPath: mdiClose, color: COLORS.gray600, size: iconCloseSize ? iconCloseSize : 'md', title: '', onClick: function () {
                            setControlledVisible(!controlledVisible);
                        }, className: 'close-icon ' + ((classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.closeIcon) ? classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.closeIcon : '') })),
                    React.createElement("div", { className: (classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popoverBodyContent) ? classNameMap === null || classNameMap === void 0 ? void 0 : classNameMap.popoverBodyContent : 'mr-x4' }, content)),
                React.createElement("div", __assign({}, getArrowProps({ className: 'tooltip-arrow' }))))))));
};
export { CustomPopover };
//# sourceMappingURL=CustomPopover.js.map